<template>
  <v-row justify="center" align="center">
    <v-col cols="12" class="text-center">
      <template v-if="lastSDAResult && lastSDAResult.Data && lastSDAResult.Data.qrURL">
        <v-icon color="success" large style="font-size: 80px;">mdi-check-circle</v-icon>
        <div class="text-h5 mt-4 mb-2">Επιτυχής Έκδοση ΔΑ!</div>
        <div class="text-subtitle-1">To Δελτιο Αποστολής εκδόθηκε με επιτυχία.</div>
        <div class="mt-6">
          <vue-qrcode :value="lastSDAResult.Data.qrURL" :size="200" class="mb-4" />
          <div class="text-subtitle-2 mt-2">
            Αριθμός Παραστατικού: <strong>{{ lastSDAResult.Data.NumberPar }}</strong>
          </div>
          <div class="text-subtitle-2 mt-1">
            Mark: <strong>{{ lastSDAResult.Data.invoiceMark }}</strong>
          </div>
        </div>
      </template>
      <template v-if="lastSDAResult && !lastSDAResult.Data?.qrURL">
        <v-alert type="warning" outlined class="mt-6">
          {{ lastSDAResult.Errors?.ErrorDetails }}
        </v-alert>
      </template>
      <v-btn color="primary" class="mt-4" @click="$emit('close')">
        Πίσω στην εφαρμογή
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import VueQrcode from 'qrcode.vue'

export default {
  name: 'SDASuccessResult',
  components: {
    VueQrcode
  },
  props: {
    lastSDAResult: {
      type: Object,
      default: null
    }
  }
}
</script> 